import { AddIcon } from "@chakra-ui/icons";
import {
  Flex,
  Spinner,
  Thead,
  Tr,
  Th,
  Table,
  Tbody,
  useDisclosure,
  TableContainer,
  Box,
  Button,
} from "@chakra-ui/react";
import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import { sortBy } from "lodash";
import React from "react";
import { tableFrameProps } from "../../components/atoms/tableFrameProps";
import { hasAccountPermission } from "../../helper/permissions";
import { useCurrentAccountStore } from "../../store/currentAccountStore";
import { useQueryGetAccount } from "../../store/useQueryGetAccount";
import { AccountAccessRow } from "./accountMemberSettings/AccountAccessRow";
import { AccountInviteRow } from "./accountMemberSettings/AccountInviteRow";
import {
  SectionHeader,
  SectionContainer,
} from "./components/SettingsComponents";
import { InviteMemberModal } from "./InviteMemberModal";

export function AccountMembersSettings() {
  return (
    <SectionContainer>
      <SectionHeader
        title="Account members"
        description="Manage who has access to this account."
      />
      <AccountMemberSettingRow />
    </SectionContainer>
  );
}

function AccountMemberSettingRow() {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const queryGetAccount = useQueryGetAccount(accountId);

  const addMemberDisclosure = useDisclosure();

  const isLoading = queryGetAccount.isLoading || !queryGetAccount.data;

  if (isLoading)
    return (
      <Flex justifyContent="center" my="40px">
        <Spinner />
      </Flex>
    );

  return (
    <>
      {hasAccountPermission(
        queryGetAccount.data,
        AccountPermission.ChangeAccess,
      ) && (
        <Button
          colorScheme="primary"
          leftIcon={<AddIcon />}
          onClick={addMemberDisclosure.onOpen}
          mb={4}
        >
          Invite member
        </Button>
      )}
      <Box {...tableFrameProps} maxW="full">
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
                <Th>Account Member</Th>
                <Th>Billing Owner</Th>
                <Th>Role</Th>
                <Th>Invite Status</Th>
                <Th w="auto"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {sortBy(
                queryGetAccount.data.access,
                (access) => access.user._id,
              ).map((accountAccess) => (
                <AccountAccessRow
                  key={accountAccess._id}
                  account={queryGetAccount.data}
                  accountAccess={accountAccess}
                />
              ))}
              {sortBy(
                queryGetAccount.data.accessInvites,
                (invite) => invite._id,
              ).map((invite) => (
                <AccountInviteRow
                  key={invite._id}
                  account={queryGetAccount.data}
                  accountInvite={invite}
                />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      {addMemberDisclosure.isOpen && (
        <InviteMemberModal disclosure={addMemberDisclosure} />
      )}
    </>
  );
}
